import React from "react";
import Select from "react-select";
import DefaultEditor from "react-simple-wysiwyg";

import { Link } from "react-router-dom";
import {Select as AntSelect} from 'antd'

const NewTicket = () => {
  const [values, setValue] = React.useState();
  function onChange(e) {
    setValue(e.target.value);
  }

  const AssignedOptions = [
    { value: "Venkatesh D", label: "Venkatesh D" },
    { value: "Venkatesh Nama", label: "Venkatesh Nama" },
    { value: "SreePavani Chivukula", label: "SreePavani Chivukula" },
    { value: "Siva", label: "Siva" },
    { value: "Sharma", label: "Sharma" },
    { value: "Pavan Sai", label: "Pavan Sai" },
  ];


  return (
    <div className="page-wrapper">
      <div className="content">
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb d-flex justify-content-between w-100">
            <div className="d-flex align-items-center">
              <li className="breadcrumb-item">
                <Link to="/crm/dashboard">
                  <i className="fas fa-home fa-lg" />
                </Link>
              </li>
              <h4 className="breadcrumb-item mb-0" aria-current="page">
                New Ticket
              </h4>
            </div>
            {/* Back to List Button */}
            <div className="page-btn">
              <Link to="/crm/tickets" className="btn btn-dark ms-2">
                <i className="ti ti-arrow-left me-1"></i>
                Back
              </Link>
            </div>
          </ol>
        </nav>

        <div className="content">
          <div className="card">
            <div className=" card-body ">
              <div className="row">
                {/* Left Column */}
                <div className="col-md-6">
                  <div className="row">
                    <div className="mb-3 col-12">
                      <label>Subject</label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter subject"
                        required
                      />
                    </div>

                    <div className="mb-3 col-12">
                      <label>Contact</label>
                      <Select
                        options={[]}
                        placeholder="Select related entity"
                      />
                    </div>

                    <div className="mb-3 col-6">
                      <label>Name</label>
                      <Select
                        options={[
                          { value: "Venkatesh D", label: "Venkatesh D" },
                          { value: "Venkatesh Nama", label: "Venkatesh Nama" },
                          {
                            value: "SreePavani Chivukula",
                            label: "SreePavani Chivukula",
                          },
                          { value: "Siva", label: "Siva" },
                          { value: "Sharma", label: "Sharma" },
                          { value: "Pavan Sai", label: "Pavan Sai" },
                        ]}
                        defaultValue={[
                          { value: "Venkatesh D", label: "Venkatesh D" },
                        ]}
                      />
                    </div>

                    <div className="mb-3 col-6">
                      <label>Email</label>
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Enter Email"
                        required
                      />
                    </div>

                    <div className="mb-3 col-6">
                      <label>Department</label>
                      <Select
                        options={[
                          { value: "Department A", label: "Department A" },
                          { value: " Department B", label: " Department B" },
                          { value: "Department C ", label: "Department C " },
                        ]}
                        defaultValue={[
                          { value: "Department A", label: "Department A" },
                        ]}
                      />
                    </div>
                    <div className="mb-3 col-6">
                      <label>CC</label>
                      <input className="form-control" type="text" />
                    </div>
                  </div>
                </div>

                {/* Divider */}
                <div className="col-md-1 d-flex align-items-center justify-content-center">
                  <div
                    style={{
                      width: "1px",
                      backgroundColor: "#ccc",
                      height: "100%",
                    }}
                  />
                </div>

                {/* Right Column */}
                <div className="col-md-5">
                  <div className="row">
                    <div className="mb-3 col-12">
                      <label>
                        <i className="fa fa-tag me-2"></i>Tags
                      </label>
                     <AntSelect                   mode="tags"
                  style={{
                    width: "100%",
                  }}
                  placeholder="Tags Mode"
                  size="large"
                  options={[
                    { value: "John Doe" },
                    { value: "Jane Smith" },
                    { value: "Alice Johnson" },
                    { value: "Bob Brown" },
                  ]}
/>
                    </div>

                    <div className="mb-3 col-12">
                      <label>Assign Ticket(default is current user)</label>
                      <Select
                        options={AssignedOptions}
                        defaultValue={AssignedOptions[0]}
                      />
                    </div>
                    <div className="mb-3 col-6">
                      <label>Priority</label>
                      <Select options={AssignedOptions} placeholder="Medium" />
                    </div>
                    <div className="mb-3 col-6">
                      <label>Service</label>
                      <Select
                        options={[
                          { value: "Service A", label: "Service A" },
                          { value: " Service B", label: " Service B" },
                          { value: "Service C ", label: "Service C " },
                        ]}
                        isMulti={true}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="row">
                <div className="mb-3 col-6">
                  <label>Ticket Body</label>
                  <Select
                    options={AssignedOptions}
                    placeholder="Insert Predefined Reply"
                  />
                </div>
                <div className="mb-3 col-6">
                  <label></label>
                  <Select
                    options={AssignedOptions}
                    placeholder="Insert Knowledge Base Link"
                  />
                </div>
                <div className="mb-3 mt-1 col-12">
                  <DefaultEditor value={values} onChange={onChange} />
                </div>
                <div className="d-flex jusify-content-end">
                  <div className="mb-3 col-8 "></div>
                  <div className="mb-1 me-0 row col-4 ">
                    <label className="col-form-label col-md-4">
                      Attachments
                    </label>
                    <div className="col-md-10">
                      <input className="form-control" type="file" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="footer d-sm-flex align-items-center justify-content-end border-top bg-white p-3">
        <p className="mb-0 text-gray-9"></p>

        <button type="submit" className="btn btn-primary">
          Open Ticket
        </button>
      </div>
    </div>
  );
};

export default NewTicket;
